/*
 * @Descripttion: 任务总览
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import moment from 'moment';
import React, {useContext} from 'react';
import {ActivityContext} from '../../index';
import styles from './index.module.scss';

const BaseInfo = () => {
  const {taskInfo} = useContext(ActivityContext);
  return (
    <div className={styles['base-info-container']}>
      <div>活动名称：{taskInfo.name}</div>
      <div>投放时间：{moment(taskInfo.sendTime).format('YYYY-MM-DD HH:mm:ss')}</div>
      <div>触点类型：{taskInfo.type}</div>
      <div>投放内容：{taskInfo.smsContent}</div>
    </div>
  )
};

export default BaseInfo;
